import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ThfDividerModule, ThfFieldModule } from '@totvs/thf-ui';

import { ThfPageBackgroundComponent } from './thf-page-background.component';

/**
 * @description
 *
 * MÃ³dulo do template do thf-page-background.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ThfDividerModule,
    ThfFieldModule,
  ],
  declarations: [
    ThfPageBackgroundComponent
  ],
  exports: [
    ThfPageBackgroundComponent
  ]
})
export class ThfPageBackgroundModule { }
